import { useTheme } from '@mui/material';
import {
  PropsWithChildren,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';

import { HeaderMobile } from '@/components/Header/HeaderMobile';

import { useScrollTop } from '@/hooks/useScrollTop';

import { ColorExtractFn } from '@/types/components/common';
import { HeaderMobileProps } from '@/types/components/layout';

import { Container, ScreenContent, ScreenFooter } from './Layout.styled';

type ScreenProps = {
  className?: string;
  center?: boolean;
  header?: HeaderMobileProps | boolean;
  footer?: ReactNode;
  bgColor?: ColorExtractFn;
  isFloat?: boolean;
  noPadding?: boolean;
} & PropsWithChildren;

export function Screen({
  className,
  header,
  children,
  center,
  footer,
  bgColor,
  noPadding,
}: ScreenProps) {
  const [contentBottom, setContentBottom] = useState(0);
  const footerRef = useRef<HTMLElement>(null);
  const theme = useTheme();

  useScrollTop();

  useEffect(() => {
    if (footer && footerRef.current) {
      setContentBottom(parseInt(getComputedStyle(footerRef.current).height));
    }
  }, [footer]);

  return (
    <>
      {header && (
        <HeaderMobile {...(typeof header !== 'boolean' ? header : {})} />
      )}
      <ScreenContent
        className={className}
        style={contentBottom ? { paddingBottom: contentBottom } : undefined}
        bgColor={bgColor?.(theme)}
      >
        <Container center={center} noPadding={noPadding}>
          {children}
        </Container>
      </ScreenContent>

      {footer && <ScreenFooter ref={footerRef}>{footer}</ScreenFooter>}
    </>
  );
}
